import { CalendarPage, EventsPage, HolidaysPage } from './index'
import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard, BlockedUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    CalendarPage,
    '/training-calendar',
    [new RequiresAuthGuard(true), new BlockedUsertypesGuard(['limited-to-contracting-signature-agent'])],
    {
      name: 'Training Calendar',
      readonly: {
        usertypes: ({ RouteDef, ProfileSrvc }) => {
          if (ProfileSrvc.isA(['affiliate-group'])) {
            if (parseInt(ProfileSrvc.get('contracts_completed')) + parseInt(ProfileSrvc.get('contracts_awaiting')) < 1)
              return '{usertype} accounts without at least 1 completed contract (includes agent writing code) do not have access to the <strong>{pageName}</strong> Page.'
            return false
          } else if (ProfileSrvc.isA(['associate-agent'])) {
            if (parseInt(ProfileSrvc.get('contracts_completed')) + parseInt(ProfileSrvc.get('contracts_awaiting')) < 6)
              return '{usertype} accounts without at least 5 completed contracts (includes agent writing code) do not have access to the <strong>{pageName}</strong> Page.'
            return false
          }
          return false
        },
      },
    }
  ),
  RouteFactory.create(
    EventsPage,
    '/events',
    [new RequiresAuthGuard(true), new BlockedUsertypesGuard(['limited-to-contracting-signature-agent'])],
    {
      name: 'USABG Events',
    }
  ),
  RouteFactory.create(
    HolidaysPage,
    '/holidays',
    [new RequiresAuthGuard(true), new BlockedUsertypesGuard(['limited-to-contracting-signature-agent'])],
    {
      name: 'USABG Holidays',
    }
  ),
]
